<template>
  <button
    id="btn"
    class="w-32 h-10 text-sm text-center uppercase
     disabled:opacity-60"
    :style="{ background: global.primaryColor, 'border-radius': '5px'}"
    :class="{
      'bg-blue-900': type === 'primary',
      'hover:bg-blue-800': type === 'primary',
      'text-white': type === 'primary',
      'bg-white': type === 'secondary',
      'hover:bg-gray-200': type === 'secondary',
      'text-black': type === 'secondary',
    }"
    @click="$emit('onClick')"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ])
  }
});
</script>

<style>
</style>
